
<div class="bg-avatar">
  <div class="d-flex align-items-center justify-content-center position-relative" :class="avatarBgClass()"
    :style="avatarBox()">
    <div v-if="avatar === null" style="color: #FFF;">{{ initial }}</div>
    <img v-else :src="avatar" alt="avatar" :style="avatarThumb()">
    <div v-if="isCompany"
      class="position-absolute bg-white rounded-circle d-flex justify-content-center align-items-center"
      style="height: 1rem; width: 1rem; right: -0.5px; bottom: -0.5px">
      <v-icon :size="10" color="rgba(63, 63, 63, 1)">mdi-domain</v-icon>
    </div>
  </div>
</div>

